const CHUNK_RELOAD_ATTEMPTED_KEY = 'chunkLoadReloadAttempted';

const isChunkLoadError = (error: Error) =>
  error?.name === 'ChunkLoadError' || error?.message?.includes('Loading chunk');

// A function that will try to re-download our failed module at a given interval. The amount of retries and the set interval is configurable
export const componentLoader = (
  lazyComponent,
  retriesLeft,
  interval
): Promise<{
  default: () => JSX.Element;
}> => {
  return new Promise((resolve, reject) => {
    lazyComponent()
      .then((module) => {
        // Clear the reload guard on success so a *later* stale chunk in the same
        // session (e.g. after a second deploy) can still trigger a reload.
        sessionStorage.removeItem(CHUNK_RELOAD_ATTEMPTED_KEY);
        resolve(module);
      })
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // If all retries failed due to a stale chunk (post-deploy), force a reload to
            // fetch the fresh bundle. A sessionStorage guard prevents infinite reload loops
            // in case the new bundle is also broken.
            if (isChunkLoadError(error) && !sessionStorage.getItem(CHUNK_RELOAD_ATTEMPTED_KEY)) {
              sessionStorage.setItem(CHUNK_RELOAD_ATTEMPTED_KEY, '1');
              window.location.reload();

              return;
            }
            sessionStorage.removeItem(CHUNK_RELOAD_ATTEMPTED_KEY);
            reject(error);

            return;
          }
          // recursive call to try to load the component again
          componentLoader(lazyComponent, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
};
